'use client';
import { isFunction } from '@s7/utils';

/**
 * Существует ли ReadableStream в контексте исполнения.
 * (Поддерживается ли Streaming API (для запросов) в контексте исполнения.)
 * */ var supportsResponseStreams = isFunction(globalThis.ReadableStream);
/** Поддерживается ли Streaming API (для запросов) в контексте исполнения */ var supportsRequestStreams = function() {
    var duplexAccessed = false;
    var hasContentType = false;
    var supportsReadableStream = isFunction(globalThis.ReadableStream);
    var supportsRequest = isFunction(globalThis.Request);
    if (supportsReadableStream && supportsRequest) {
        hasContentType = new globalThis.Request("https://empty.invalid", {
            body: new globalThis.ReadableStream(),
            method: "POST",
            // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error, @typescript-eslint/ban-ts-comment
            // @ts-ignore - Типы могут быть устаревшими. Эта часть кода корректна.
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        }).headers.has("Content-Type");
    }
    return duplexAccessed && !hasContentType;
}();
/** Поддерживается ли AbortController в контексте исполнения */ var supportsAbortController = isFunction(globalThis.AbortController);
/** Поддерживается ли FormData в контексте исполнения */ var supportsFormData = isFunction(globalThis.FormData);

export { supportsAbortController, supportsFormData, supportsRequestStreams, supportsResponseStreams };
